import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SIRGPD_LAB_CRD;

export default {
  post(payload) {
    return baseApi.post(resource, payload);
  },
  put(payload) {
    return baseApi.post(resource, payload);
  },
};
